export default __webpack_public_path__ + "static/media/cobrauc3.017c5518.jpg";